// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df8ae89e","453":"85160994","732":"efaa527a","977":"2020cb0b"}[chunkId] + ".chunk.js";
};